import { subscribe, useSnapshot } from "valtio";
import ReactTablePagination from "../components/ag-table/ReactTablePagination";
import AgLastUpload, { AgLastUpload1, AgLastUpload2 } from "../components/AgLastUpload";
import { taskStore } from "../mytasks/task-store";
import { configStore, creditControlStore, loginStore } from "../state/CommonState";
import { menucountStore } from "../state/menuStore";
import MonApi from "../state/mongo-api";
import { GiCargoShip } from "react-icons/gi";
import Utils from "../util/Utils";
import ShipmentGraph, { graphNode } from "./shipment-graph";
import { myactionsstore } from "./store-myactions";
import { RouteReviewBanner } from "./RouteReviewBanner";
import React,{useState,useEffect, useRef} from "react";
import {useTable,usePagination,useSortBy} from "react-table"
import { QueryClient,QueryClientProvider } from "react-query";

//mychanges
import { dataListStore, modalStore } from "../state/CommonState";
import { Agyesno } from "../components/Agyesno";
import { AgUnloc, AgUnloc1, TableSelect5 } from "../components/AgComponents";




import {reducer,PAGE_CHANGED,PAGE_SIZE_CHANGED,PAGE_SORT_CHANGED,PAGE_FILTER_CHANGED,TOTAL_COUNT_CHANGED,PAYLOAD_CHANGED} from "../components/ag-table/ag-reducer"
import { DRS_COLUMNS } from "../components/ag-table/columns";
import ApiAgTable from "../components/ag-table/api_ag-table";
import { OneDate, OneInput5, OneSelect4 } from "../mytasks/act-common";
import Api from "../state/Api";
import EntityApi from "../state/entity-api";
import { AgUnlocdsr } from "../components/AgComponents";
import { loader } from "../util/loader";
import { VisibilityGraph } from "./visibilitygraph";
import { Visibility } from "./visibility";
import { DsrModal } from "./dsrmodal";
import { Typography } from "@mui/material";
import { Nodata } from "../mui-components/nodatafound";
import { useLocation } from "react-router";
import UpdateCutOffPopup from "./updateCutOffPopup";
import { BsReceiptCutoff } from "react-icons/bs";
import RoleUtils from "../util/RoleUtils";
import { PERMISSIONS_NEW } from "../util/constants";
import ContainerUpdatePopup from "./containerUpdatePopup";

const queryClient = new QueryClient()

const initialState = {
    queryPageIndex: 0,
    queryPageSize: 10,
    totalCount: 0,
    queryPageFilter: "",
    queryPageSortBy: [],
    queryPayload: {}
};

const TableLine = (props) => {
    let { label, value } = props
    if (value) value = Utils.reformatSuffixedDate(value)
    if (value) {
        return (
            <tr>
                <td style={{ fontWeight: 'bold', textAlign: 'right', paddingRight: '10px',width:'50%' }}>{label}</td>
                <td style={{overflowWrap: 'anywhere'}}>{value}</td>
            </tr>
        )
    }
    return <></>
}
const DataTable = (props) => {
    useSnapshot(myactionsstore)
    useSnapshot(configStore)
    useSnapshot(creditControlStore)

    useEffect(() => {
        if (!creditControlStore.list || creditControlStore.list.length === 0) {
            EntityApi.getCreditControl()
        }
    }, [])
    const filterStatus = {
        'fcl':'FCL',
        'lcl':'LCL',
        'air':'AIR'
    }
    const authorizedFilters = Utils.getAuthProductList(filterStatus)
    const filterStatus1 = {
        'In-transit': 'In-transit',
        'Complete': 'Complete'
    }
    const location = useLocation().pathname;
    const [graphList, setGraphList] = useState([])
    const [containerPopup, setContainerPopup] = useState(false)
    const [updateCutOff, setUpdateCutOff] = useState(false)
    const [elist, setElist] = useState([])
    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryPayload }, dispatch] =
    React.useReducer(reducer, initialState);
    const totalPageCount = Math.ceil(totalCount / queryPageSize)
    const [data1, setData1] = useState({ results: [] })
    let columns = DRS_COLUMNS
    const [search, setSearch] = useState('')
    const [selectedFilter, SetSelectedFilter] = useState(`ALL`);
    const buttonRef = useRef(null);
    const [selected1Filter, SetSelected1Filter] = useState(`ALL`);
    let entity = 'ALL'
    if (loginStore.isClient()) entity = configStore.currentSelectedEntity.entityId
    let url = `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/downloadxl/${entity}`
    let urlzip = `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/downloadzip/${entity}`

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        state: { pageIndex, pageSize, sortBy }
    } = useTable({
        columns,
        data: data1?.results,
        initialState: {
            pageIndex: queryPageIndex,
            pageSize: queryPageSize,
            sortBy: queryPageSortBy,
        },
        manualPagination: true,
        pageCount: data1 ? totalPageCount : null,
        autoResetSortBy: false,
        autoResetExpanded: false,
        autoResetPage: false
    },
        useSortBy,
        usePagination,
    );
   
   

    const manualPageSize = []
    // useEffect(()=>{
    //     if (configStore.currentURL.startsWith("/visibility/view")) {
    //         const visibilityId = location.split('/').at(3);
    //         if(visibilityId){
    //             setSearch(visibilityId);
    //         }
    //     }
    // },[]) 

    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: pageIndex });
    }, [pageIndex,gotoPage]);

    useEffect(() => {
        dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
        gotoPage(0);
    }, [pageSize, gotoPage]);

    useEffect(() => {
        dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });
        gotoPage(0);
    }, [sortBy, gotoPage]);

    useEffect(() => {
        if (configStore.currentURL.startsWith("/visibility/view")) {
            const visibilityId = location.split('/').at(3);
            if(visibilityId){
                setTimeout(()=>{
                  dispatch({ type: PAYLOAD_CHANGED, payload: { search:visibilityId,filter:selectedFilter,filter1:selected1Filter } });
                setSearch(visibilityId);
                },0)
            }
        }else{
            dispatch({ type: PAYLOAD_CHANGED, payload: { search:search,filter:selectedFilter,filter1:selected1Filter } });
        }
        gotoPage(0);
    }, [selectedFilter,selected1Filter, gotoPage]);

    useEffect(() => {
        if (search.length === 0) {
            dispatch({ type: PAYLOAD_CHANGED, payload: { search:search,filter:selectedFilter,filter1:selected1Filter } });
            gotoPage(0);
        }
    }, [search]);

    const onClickSearch = () => {
        if (search.length > 0) {
            dispatch({ type: PAYLOAD_CHANGED, payload: { search:search,filter:selectedFilter,filter1:selected1Filter } });
            gotoPage(0);
        }else{
            configStore.setModalMessage(`Please Provide Valid Input`)  
        }
    };


    function setlist() {
        //setData1({results : myactionsstore.list, count:myactionsstore.count})
        let eli = []
        let graphList1 = []
        for (let i = 0; i < myactionsstore.list.length; i++) {
            let rec = myactionsstore.list[i]
            let oneGraph = []
            console.log("the rec is ",rec)
            oneGraph = Visibility.GraphLine(rec)
            // console.log("oneGraph",i+1,oneGraph);
        if (rec?.icegateResData && rec?.icegateResData?.oocDt) {
            oneGraph[oneGraph?.length-1].r7 = `OOC ${Utils.convertICEGATEDate(rec?.icegateResData?.oocDt,2)}`
        }
        if (rec?.icegateResData && rec?.icegateResData?.leoDt) {
            oneGraph[0].r7 =`LEO ${Utils.convertICEGATEDate(rec?.icegateResData?.leoDt,2)}`
        }
            // if (rec.shipmentType !== 'Air') oneGraph = Visibility.oceanGraphLine(rec)
            // else oneGraph = Visibility.airGraphLine(rec)
            let activeOn = false
            let lastactive = -1
            for (let i = oneGraph.length - 1; i >= 0; i--) {
                let node = oneGraph[i]
                if(rec.status_closed == 'Y' || rec.status_closed == 'Yes' || rec.booking.status == 'ARCHIVED'){
                    node.isActive = true
                }
                if (node.isActive && !activeOn) {
                    node.activelines = 1
                    lastactive = i
                }
                if (node.isActive) activeOn = true
                if (activeOn && !node.isActive) node.isActive = true
                if (node.isActive && i < lastactive) node.activelines = 2
            }
            graphList1.push(oneGraph)
            eli.push(rec)
            console.log("graphList1",graphList1);
            setGraphList(graphList1)
        }
        setElist(eli)
    }

    React.useEffect(() => {
        if (data1?.count) {
            dispatch({
                type: TOTAL_COUNT_CHANGED,
                payload: data1.count,
            });
        }
    }, [data1?.count]);

    useEffect(() => {
        console.log('*** subscribing ***********')
        const unsubscribe = subscribe(myactionsstore, () => {
            setlist()
        })
        return unsubscribe
    },[myactionsstore,data1])

    useEffect(() => {
        console.log('*** GETTING ALL THE DSR')
        //Newapi.getAllDsr4Display();
        if(queryPayload.filter && queryPayload.filter1){
            loader.show()
            ApiAgTable.getAllDsr4Display(queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryPayload).then(res=>{
                res.clone().json().then((res) => {
                    let lres = res;
                    if (lres?.results1 && Array.isArray(lres.results1)) {
                        for (let i = 0; i < lres.results1.length; i++) {
                            if (lres.results1[i]?.['booking'] && lres.results1[i]['booking']['containershow'] === undefined) {
                                lres.results1[i]['booking']['containershow'] = -1;
                            }
                        }
                        myactionsstore.setList(lres.results1);
                        setData1({ results: lres.results, count: lres.count });
                    } else {
                        myactionsstore.list = [];
                        setData1({ count: 0, results: [] });
                    }
                    loader.hide();
                }, err => {
                    console.log(err);
                    loader.hide();
                });
            });
        }
        
},[queryPayload,queryPageIndex,queryPageSize,queryPageFilter,queryPageSortBy,configStore.currentSelectedEntity, configStore.currentSelectedBranch,myactionsstore.recheck])

return (
    <div style={{flex:1}}>
        <RouteReviewBanner />
        {/* <ActrejectModal7/> */}
        
        <div className="box is-fullwidth" style={{ flex: 1, backgroundColor: "transparent", border: "none", boxShadow: loginStore.isClient() ? "none" : "initial" }}>
  <div className="columns is-vcentered is-mobile" style={{ marginBottom: "0.5rem" }}>
  {/* Visibility Title (unchanged size) */}
  <div className="column is-2">
    <h4 className="title is-3 mb-0">Visibility</h4>
  </div>

  <div className="column is-12">
  <div
    className="is-flex is-align-items-center"
    style={{ gap: "1rem", flexWrap: "wrap" }}
  >
    {/* Search */}
    <div className="field has-addons">
      <p className="control is-expanded">
        <input
          className="input is-small"
          value={search}
          onChange={(e) => {
            configStore.currentURL = "";
            setSearch(e.target.value);
          }}
          onKeyUp={(e) => {
            if (e.key === "Enter") {
              configStore.currentURL = "";
              setSearch(e.target.value);
              onClickSearch();
            }
          }}
          placeholder="Search"
        />
      </p>
      <p className="control">
        <button
          className="button is-small"
          style={{
            backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
            color: "#fff",
          }}
          onClick={onClickSearch}
        >
          Search
        </button>
      </p>
    </div>

    {/* Shipment Type */}
    <div className="field is-flex is-align-items-center" style={{ gap: "0.5rem" }}>
      <label className="label is-small mb-0">Type</label>
      <div className="select is-small">
        <select
          value={selectedFilter}
          onChange={(e) => SetSelectedFilter(e.target.value)}
        >
          <option value="ALL">ALL</option>
          {Object.entries(authorizedFilters).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* Status */}
    <div className="field is-flex is-align-items-center" style={{ gap: "0.5rem" }}>
      <label className="label is-small mb-0">Status</label>
      <div className="select is-small">
        <select
          value={selected1Filter}
          onChange={(e) => SetSelected1Filter(e.target.value)}
        >
          <option value="ALL">ALL</option>
          {Object.entries(filterStatus1).map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* DSR */}
    {!loginStore.isClient() && (
      <div className="title is-7 mb-0">Pending DSR: {menucountStore.pendingdsr}</div>
    )}

    {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.VISIBILITY.EDIT) && <button
      className="button is-small"
      style={{
        fontSize: "12px",
        backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
        color: "#fff",
      }}
      onClick={() => {
      setContainerPopup(true);
    }}
    >
      Container Update
    </button>}

    {/* Cut-Offs */}
    {!loginStore.isClient() && (
      <button
        ref={buttonRef}
        className="button is-small px-3"
        style={{
          fontSize: "12px",
          backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
          color: "#fff",
        }}
        onClick={() => setUpdateCutOff(!updateCutOff)}
      >
        <span>Cut-Offs </span>
        <BsReceiptCutoff size={16} />
      </button>
    )}
  </div>
   {updateCutOff && (
                <UpdateCutOffPopup
                    isOpen={updateCutOff}
                    onClose={() => setUpdateCutOff(false)}
                    anchorRef={buttonRef}
                />
            )}
</div>

    </div>

            {
                graphList?.length > 0 ?
                graphList.map((e, i) => {
                    let e1 = elist[i]
                    console.log(" the e1 is ",e1)
                    if(e1){
                        return <VisibilityGraph key={e1._id} graphNodes={e} dsrRec={e1} />
                    }
                }) : <Nodata width="250px" height="250px"/>
            }
            <ReactTablePagination
                page={page}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                pageSize={pageSize}
                pageIndex={pageIndex}
                pageCount={pageCount}
                setPageSize={setPageSize}
                manualPageSize={manualPageSize}
                dataLength={totalCount}
                rows={rows}
            />
        </div>

        <ContainerUpdatePopup visible={containerPopup} setVisible={setContainerPopup}/>
        
      

<DsrModal graphList={graphList} />
    </div>
)

}


const CustomerMyactions = (props) => {
    return (
        <QueryClientProvider client={queryClient}>
            <DataTable />
        </QueryClientProvider>
    )
}

export default CustomerMyactions;